import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IWohaActionProps } from "./WohaAction.props";
const styles = {
  primary: "border-charcoal bg-charcoal text-white hover:bg-graphite",
  secondary: "border-ash bg-white text-charcoal hover:border-smoke hover:bg-paper-mist",
  ghost: "border-transparent bg-transparent text-charcoal hover:bg-paper-mist",
  destructive: "border-red-700 bg-red-700 text-white hover:bg-red-800",
} as const;
export const WohaAction = ({ action, className }: IWohaActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "inline-flex min-h-11 items-center justify-center rounded-lg border px-5 py-2.5 text-sm font-medium transition-[background-color,border-color,transform] duration-200 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-blue active:scale-[0.98]",
        styles[action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      {action.label}
    </Link>
  );
};
WohaAction.displayName = "Content::WohaAction";
